// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
    en: {
        translation: {

            products: require('./locales/en/products.json'),

            hero_page_title: "Welcome!",
            hero_page_subtitle: 'Smart, Safe & Super Fun for Every Kid!',
            hero_page_button: "Pre-order now",
            home_screen_products_title: "Dofi In Action",
            add_to_cart_text: "Add to cart",
            about_title: "Inside",
            about_description: "Our robot is a smart, engaging companion designed to support children's development through voice command interaction, video calling with parental controls, and dynamic body and facial expressions. It helps kids learn both their native language and English, enjoy interactive storytelling, and build strong math and logic skills, all while having fun.",
            about_feature_part1: "Cognitive Growth",
            about_feature_part2: "Enhanced Problem-Solving",
            about_feature_part3: "Adaptive Learning",
            about_feature_part4: "Personalized Feedback",

            safety_page_title: "Artificial Intelligence and Security",
            safety_page_description: "We take security seriously. Every byte of your child's data is protected within our closed system. Dofi sets a new standard for family-friendly artificial intelligence.",
            safety_page_feature_title_part1: "Useful for parents",
            safety_page_feature_desciption_part1: "From secure calls to real-time progress reports",
            safety_page_feature_title_part2: "Better parenting tools",
            safety_page_feature_description_part2: "Parent App that clearly presents child's educational plans and identifies developmental milestones",
            safety_page_feature_title_part3: "Safe, secure and private",
            safety_page_feature_description_part3: "kidSAFE+ COPPA certified device with customizable security and privacy settings",

            // FAQ
            faq_title: "Frequently Asked Questions",
            faq_question_part1: "What is Dofi?",
            faq_answer_part1: "Dofi is an AI-powered talking learning robot designed for children, small in size but big in personality.",
            faq_question_part2: "How does Dofi work?",
            faq_answer_part2: "Dofi uses advanced artificial intelligence algorithms to interact with children, teach them new skills, and provide a fun, engaging learning experience.",
            faq_question_part3: "Is Dofi safe for kids?",
            faq_answer_part3: "Yes, Dofi is designed with safety in mind. It has enhanced encryption and parental controls to ensure a safe and secure experience for kids.",
            faq_question_part4: "What age group is Dofi suitable for?",
            faq_answer_part4: "Dofi is suitable for children between the ages of 3 and 8.",
            faq_question_part5: "How do I pre-order Dofi?",
            faq_answer_part5: "You can pre-order Dofi directly from our website. Simply add the product to your cart and proceed to checkout.",

            // Profile
            profile_page_title: "Personal informations",
            profile_page_form_label1: "Name and Surname",
            profile_page_form_label2: "Email",
            profile_page_form_label3: "Contact number",
            profile_page_form_button: "Update",
            profile_page_modal_desc: "Your profile has been successfully updated",

            // Profile Orders
            profile_orders_page_title: "Your orders",
            profile_order_card_part1: "Order code",
            profile_order_card_part2: "Order date",
            profile_order_card_part3: "Detailed information",
            profile_order_card_part4: "Total price",

            // Profile Order Details Card
            profile_orders_details_part1: "Delivery",
            profile_orders_details_part2: "Country",
            profile_orders_details_part3: "City",
            profile_orders_details_part4: "Address",
            profile_orders_details_part5: "Contact",
            profile_orders_details_part6: "Full name",
            profile_orders_details_part7: "Email",
            profile_orders_details_part8: "Phone",
            profile_orders_details_part9: "Payment",
            profile_orders_details_part10: "Payment status",
            profile_orders_details_part11: "Payment type",
            profile_orders_details_part12: "Ordered products",
            profile_orders_details_part13: "Price",
            profile_orders_details_part14: "Delivery",
            profile_orders_details_part15: "Total price",
            profile_orders_details_part16: "Discount",

            // Profile Security
            profile_security_page_title: "Security",
            profile_security_form_label1: "Current password",
            profile_security_form_placeholder1: "Enter your current password",
            profile_security_form_label2: "New password",
            profile_security_form_placeholder2: "Enter your new password",
            profile_security_form_label3: "Confirm password",
            profile_security_form_placeholder3: "Confirm your password",
            profile_security_form_button: "Change password",
            profile_security_modal_desc: "Your password has been successfully updated!",

            // Sidebar
            sidebar_title_profile: "Profile",
            sidebar_title_orders: "Orders",
            sidebar_title_security: "Security",
            sidebar_title_logout: "Log out",

            // Breadcrumb
            breadcrumb_home: "Home",
            breadcrumb_profile: "Profile",
            breadcrumb_orders: "Orders",
            breadcrumb_order: "Order",
            breadcrumb_security: "Security",

            // Footer
            footer_title1: "Products",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Bag for Dofi",
            footer_title2: "Shipping & Policy",
            footer_part5: "About",
            footer_part6: "Shipping information",
            footer_part7: "Return Policy",
            footer_part8: "Privacy Policy",
            footer_part9: "Terms of Service",
            footer_title3: "Follow us",
            footer_part10: "Email",
            footer_part11: "Phone",
            footer_part12: "All Rights Reserved",

            // Product details
            product_details_part1: "Color",
            product_details_part2: "Quantity",
            product_details_part3: "Add to cart",
            product_details_part4: "Pre-order now",
            product_details_part5: "Detailed information",
            product_details_part6: "Shipping calculated at checkout",

            // Order checkout
            order_checkout_parttitle: "Pre-order page",
            order_checkout_part1: "Contact",
            order_checkout_part2: "Email",
            order_checkout_part3: "Enter your email",
            order_checkout_part4: "Full name",
            order_checkout_part5: "Write the full name",
            order_checkout_part6: "Choose your country",
            order_checkout_part7: "Choose your city",
            order_checkout_part8: "Select your city",
            order_checkout_part9: "Address",
            order_checkout_part10: "Enter your address",
            order_checkout_part11: "Apartment",
            order_checkout_part12: "Enter your apartment",
            order_checkout_part13: "Phone number",
            order_checkout_part14: "7 digit number",
            order_checkout_part15: "Confirm pre-order",
            order_checkout_part16: "Delivery",
            order_checkout_part17: "Select your country",
            order_checkout_part18: "Your order created as pre-order",
            order_checkout_part19: "Postal code",
            order_checkout_part20: "Enter postal code",

            // Order Summary
            order_summary_title: "Order summary",
            order_summary_part1: "Color",
            order_summary_part2: "Price",
            order_summary_part3: "Enter promo code",
            order_summary_part4: "Check",
            order_summary_part5: "Product price",
            order_summary_part6: "Delivery",
            order_summary_part7: "Discount",
            order_summary_part8: "Total price",
            order_summary_part9: "Your cart is empty",

            // Card modal
            card_modal_title: "Cart",
            cart_modal_footer: "Proceed to checkout",
            cart_modal_message1: "Continue to shopping",
            cart_modal_message2: "Your cart is empty",

            // Register
            register_page_title: "Create your account now with just one click",
            register_page_label1: "Name and Surname",
            register_page_input1: "Enter your name and surname",
            register_page_label2: "Email",
            register_page_input2: "Enter your email",
            register_page_label3: "Pasword",
            register_page_input3: "Enter your password",
            register_page_button: "Sign up",
            register_page_footer1: "Already have an account",
            register_page_footer2: "Sign in",

            // Login
            login_page_title: "We are glad to see you again!",
            login_page_label1: "Email",
            login_page_input1: "Enter your email",
            login_page_label2: "Password",
            login_page_input2: 'Enter your password',
            login_page_button: "Login",
            login_page_footer1: "Don't have an account?",
            login_page_footer2: "Sign Up",
            login_page_footer3: "Forgot your password",

            // Forgot
            forgot_page_title: "Repair your password",
            forgot_page_label1: "Email",
            forgot_page_input1: "Enter your email",
            forgot_page_button: "Change password",
            forgot_page_footer1: "Do you have an account?",
            forgot_page_footer2: "Login",

            // Cart
            cart_page_part1: "Your cart",
            cart_page_part2: "Continue",
            cart_page_part3: "Product",
            cart_page_part4: "Amount",
            cart_page_part5: "Total Price",
            cart_page_part6: "Proceed to payment",

            modal_success_message_title: "Success",
            modal_success_message_description: "Product added to cart",
            modal_success_button: "Close",
            modal_error_message_title: "Error",
            modal_error_message_description: "Error occured",
            modal_error_button: "Close",
            modal_login_message_title: "Success",
            modal_login_message_description: "You've succesfully logged!",
            modal_register_message_description: "You've succesfully registered",



            // Validation messages
            validation_email: "Email is required",
            validation_email_invalid: "Email is invalid",
            validation_password: "Password is required",
            validation_fullName: "Name is required",
            validation_phone: "Phone number is required",
            validation_address: "Address is required",
            validation_country: "Country is required",
            validation_city: "City is required",


            // About
            about_page_title: "Hello, World",
            about_page_title2: "We're Dofi",
            about_page_description: "Behind every great robot is a curious mind and a team of dreamers. Learn how Dofi came to life—and the humans who gave it a heart.",
            about_page_info: "Dofi began as a spark of curiosity between Vugar Hasanov and Sanan Muzaffarov — a shared dream to build a robot that felt alive. With Laman Hasanova crafting its playful personality through UI/UX, Huseyn and Valida Adilova shaping its iconic 3D form, and Anar Aghazada bringing visual harmony through his graphic design touch, Dofi slowly winked into existence. Guided by a community of mentors and fueled by late-night ideas and stubborn problem-solving, this robot isn’t just ours; it’s a mosaic of creativity, collaboration, and the kind of magic that happens when the right people come together.",

        },
    },
    az: {
        translation: {

            products: require('./locales/az/products.json'),

            hero_page_title: "Xoş gəlmisiniz!",
            hero_page_subtitle: 'Hər Uşaq üçün Ağıllı, Təhlükəsiz və Super Əyləncəli!',
            hero_page_button: "Ön sifariş et",
            home_screen_products_title: "Dofi Fəaliyyətdədir",
            add_to_cart_text: "Səbətə əlavə et",

            about_title: "Daxilində",
            about_description: "Robotumuz səsli əmrlə qarşılıqlı əlaqə, valideyn nəzarəti ilə video zəng, dinamik bədən və üz ifadələri vasitəsilə uşaqların inkişafını dəstəkləmək üçün nəzərdə tutulmuş ağıllı, cəlbedici yoldaşdır. O, uşaqlara həm ana dilini, həm də ingilis dilini öyrənməyə, interaktiv hekayələrdən həzz almağa və əylənərkən güclü riyaziyyat və məntiq bacarıqlarını inkişaf etdirməyə kömək edir.",
            about_feature_part1: "Məntiqi artım",
            about_feature_part2: "Təkmilləşdirilmiş Problemlərin Həlli",
            about_feature_part3: "Adaptiv Öyrənmə",
            about_feature_part4: "Fərdi Əlaqə",

            safety_page_title: "Süni İntellekt və Təhlükəsizlik",
            safety_page_description: "Biz təhlükəsizliyə ciddi yanaşırıq. Övladınızın məlumatlarının hər baytı bizim qapalı sistemimiz çərçivəsində qorunur. Dofi ailə dostu süni intellekt üçün yeni standart müəyyən edir.",
            safety_page_feature_title_part1: "Valideynlər üçün faydalıdır",
            safety_page_feature_desciption_part1: "Təhlükəsiz zənglərdən real vaxt tərəqqi hesabatlarına qədər",
            safety_page_feature_title_part2: "Daha yaxşı valideynlik vasitələri",
            safety_page_feature_description_part2: "Uşağın təhsil planlarını aydın şəkildə təqdim edən və inkişaf mərhələlərini müəyyən edən Valideyn Proqramı",
            safety_page_feature_title_part3: "Təhlükəsiz, təhlükəsiz və şəxsi",
            safety_page_feature_description_part3: "Fərdiləşdirilə bilən təhlükəsizlik və məxfilik parametrləri ilə kidSAFE+ COPPA sertifikatlı cihaz",

            faq_title: "Tez-tez soruşulan suallar",
            faq_question_part1: "Dofi nədir?",
            faq_answer_part1: "Dofi uşaqlar üçün nəzərdə tutulmuş, kiçik ölçülü, lakin şəxsiyyət baxımından böyük olan süni intellektlə işləyən danışan öyrənmə robotudur.",
            faq_question_part2: "Dofi necə işləyir?",
            faq_answer_part2: "Dofi uşaqlarla ünsiyyət qurmaq, onlara yeni bacarıqlar öyrətmək və əyləncəli, cəlbedici öyrənmə təcrübəsi təmin etmək üçün qabaqcıl süni intellekt alqoritmlərindən istifadə edir.",
            faq_question_part3: "Dofi uşaqlar üçün təhlükəsizdir mi?",
            faq_answer_part3: "Bəli, Dofi təhlükəsizlik nəzərə alınmaqla hazırlanmışdır. Uşaqlar üçün təhlükəsiz və təhlükəsiz təcrübə təmin etmək üçün təkmilləşdirilmiş şifrələmə və valideyn nəzarətinə malikdir.",
            faq_question_part4: "Dofi hansı yaş qrupu üçün uyğundur?",
            faq_answer_part4: "Dofi 3-8 yaş arası uşaqlar üçün uyğundur.",
            faq_question_part5: "Dofi-ni necə əvvəlcədən sifariş edə bilərəm?",
            faq_answer_part5: "Dofi-ni birbaşa saytımızdan öncədən sifariş edə bilərsiniz. Sadəcə olaraq məhsulu səbətinizə əlavə edin və ödənişə davam edin.",

            // Profile
            profile_page_title: "Şəxsi məlumatlar",
            profile_page_form_label1: "Ad və soyad",
            profile_page_form_label2: "E-poçt",
            profile_page_form_label3: "Əlaqə nömrəsi",
            profile_page_form_button: "Yenilə",
            profile_page_modal_desc: "Profiliniz uğurla yeniləndi",

            // Profile Orders
            profile_orders_page_title: "Sənin sifarişlərin",
            profile_order_card_part1: "Sifariş kodu",
            profile_order_card_part2: "Sifariş tarixi",
            profile_order_card_part3: "Sifariş detalları",
            profile_order_card_part4: "Ümumi qiymət",

            // Profile Order Details Card
            profile_orders_details_part1: "Çatdırılma",
            profile_orders_details_part2: "Ölkə",
            profile_orders_details_part3: "Şəhər",
            profile_orders_details_part4: "Ünvan",
            profile_orders_details_part5: "Əlaqə",
            profile_orders_details_part6: "Ad və soyad",
            profile_orders_details_part7: "E-poçt",
            profile_orders_details_part8: "Telefon nömrəsi",
            profile_orders_details_part9: "Ödəniş",
            profile_orders_details_part10: "Ödəniş statusu",
            profile_orders_details_part11: "Ödəniş növü",
            profile_orders_details_part12: "Sifariş olunan məhsullar",
            profile_orders_details_part13: "Qiymət",
            profile_orders_details_part14: "Çatdırılma",
            profile_orders_details_part15: "Ümumi qiymət",
            profile_orders_details_part16: "Endirim",

            // Profile Security
            profile_security_page_title: "Təhlükəsizlik",
            profile_security_form_label1: "Mövcud şifrə",
            profile_security_form_placeholder1: "Mövcud şifrənizi yazın",
            profile_security_form_label2: "Yeni şifrə",
            profile_security_form_placeholder2: "Yeni şifrənizi yazın",
            profile_security_form_label3: "Parolunuzu təsdiqləyin",
            profile_security_form_placeholder3: "Parolunuzu təsdiq edin",
            profile_security_form_button: "Parolunuzu dəyişin",
            profile_security_modal_desc: "Sənin şifrən uğurla dəyişdirildi",

            // Sidebar
            sidebar_title_profile: "Profil",
            sidebar_title_orders: "Sifarişlər",
            sidebar_title_security: "Təhlükəsizlik",
            sidebar_title_logout: "Çıxış et",

            // Breadcrumb
            breadcrumb_home: "Ana səhifə",
            breadcrumb_profile: "Profil",
            breadcrumb_orders: "Sifarişlər",
            breadcrumb_order: "Sifariş",
            breadcrumb_security: "Təhlükəsizlik",

            // Footer
            footer_title1: "Məhsullar",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Dofi çantası",
            footer_title2: "Çatdırılma & Siyasət",
            footer_part5: "Haqqında",
            footer_part6: "Çatdırılma",
            footer_part7: "Qaytarılma siyasəti",
            footer_part8: "Məxfiləşdirmə siyasəti",
            footer_part9: "Xidmət şərtləri",
            footer_title3: "Bizi izləyin",
            footer_part10: "E-poçt",
            footer_part11: "Əlaqə",
            footer_part12: "Bütün hüquqlar qorunur",

            // Product details
            product_details_part1: "Rəng",
            product_details_part2: "Say",
            product_details_part3: "Karta əlavə et",
            product_details_part4: "Ön sifariş et",
            product_details_part5: "Detallı məlumat",
            product_details_part6: "Çatdırılma hesablanacaq",

            // Order checkout
            order_checkout_parttitle: "Ön sifariş səhifəsi",
            order_checkout_part1: "Əlaqə",
            order_checkout_part2: "E-poçt",
            order_checkout_part3: "E-poçtunuzu daxil edin",
            order_checkout_part4: "Ad və soyad",
            order_checkout_part5: "Adınızı daxil edin",
            order_checkout_part6: "Ölkə seçin",
            order_checkout_part7: "Şəhər seçin",
            order_checkout_part8: "Şəhər seçin",
            order_checkout_part9: "Ünvan",
            order_checkout_part10: "Ünvanı daxil edin",
            order_checkout_part11: "Bina",
            order_checkout_part12: "Binanı daxil edin",
            order_checkout_part13: "Əlaqə",
            order_checkout_part14: "7 rəqəmli nömrə",
            order_checkout_part15: "Ön sifariş et",
            order_checkout_part16: "Çatdırılma",
            order_checkout_part17: "Ölkə seçin",
            order_checkout_part18: "Sənin sifarişin yaradıldı",

            // Order Summary
            order_summary_title: "Sifariş özəti",
            order_summary_part1: "Rəng",
            order_summary_part2: "Qiymət",
            order_summary_part3: "Promo kodu daxil edin",
            order_summary_part4: "Yoxla",
            order_summary_part5: "Məhsul qiyməti",
            order_summary_part6: "Çatdırılma",
            order_summary_part7: "Endirim",
            order_summary_part8: "Ümumi qiymət",
            order_summary_part9: "Sənin səbətin boşdur",

            // Card modal
            card_modal_title: "Səbət",
            cart_modal_footer: "Sifarişi tamamla",
            cart_modal_message1: "Alış-verişə davam et",
            cart_modal_message2: "Sənin səbətin boşdur",

            // Register
            register_page_title: "Sadəcə bir toxunuşla hesabınızı yaradın",
            register_page_label1: "Ad və Soyad",
            register_page_input1: "Adınızı və soyadınızı daxil edin",
            register_page_label2: "E-poçt",
            register_page_input2: "E-poçtunuzu yazın",
            register_page_label3: "Şifrə",
            register_page_input3: "Şifrənizi yazın",
            register_page_button: "Qeydiyyatdan keç",
            register_page_footer1: "Artıq hesabınız var?",
            register_page_footer2: "Daxil olun",

            // Login
            login_page_title: "Sizi yenidən görməyə şadıq",
            login_page_label1: "E-poçt",
            login_page_input1: "E-poçtunuzu yazın",
            login_page_label2: "Şifrə",
            login_page_input2: "Şifrənizi yazın",
            login_page_button: "Daxil olun",
            login_page_footer1: "Hesabınız yoxdur?",
            login_page_footer2: "Qeydiyyatdan keçin",
            login_page_footer3: "Şifrənizi unutmusunuz?",

            // Login
            forgot_page_title: "Parolu təmin et",
            forgot_page_label1: "E-poçt",
            forgot_page_input1: "E-poçtunuzu daxil edin",
            forgot_page_button: "Şifrəni dəyiş",
            forgot_page_footer1: "Hesabınız var?",
            forgot_page_footer2: "Daxil ol",

            // Cart
            cart_page_part1: "Səbət",
            cart_page_part2: "Davam et",
            cart_page_part3: "Məhsul",
            cart_page_part4: "Miqdar",
            cart_page_part5: "Ümumi qiymət",
            cart_page_part6: "Ödənişə doğru irəlilə",

            // Modal
            modal_success_message_title: "Uğurlu",
            modal_success_message_description: "Məhsul əlavə olundu",
            modal_success_button: "Bağla",
            modal_error_message_title: "Xəta",
            modal_error_message_description: "Xəta baş verdi!",
            modal_error_button: "Bağla",
            modal_login_message_title: "Uğurlu!",
            modal_login_message_description: "Siz uğurla daxil oldunuz!",
            modal_register_message_description: "Siz uğurla qeydiyyatdan keçdiniz!",

            // About
            about_page_title: "Salam, Dünya",
            about_page_title2: "Biz Dofi'yik",
            about_page_description: "Hər böyük robotun arxasında maraqlı bir zəkâ və xəyalpərəstlərdən ibarət bir komanda dayanır. Dofi'nin necə yarandığını və ona ürək verən insanları öyrənin.",
            about_page_info: "Dofi, Vüqar Həsənov və Sənan Müzəffərov arasında yaranan maraq qığılcımı ilə başladı — canlı kimi hiss olunan bir robot yaratmaq arzusu ilə. Onun oyunçu şəxsiyyətini Ləman Həsənova UI/UX vasitəsilə formalaşdırdı, Hüseyn və Validə Adilova onun ikonik 3D formasını yaratdı, Anar Ağazadə isə qrafik dizaynla vizual harmoniya qatdı. Mentorlar icmasının rəhbərliyi və gecəyarısı ideyaları ilə qidalanan inadkar problem həll etmə əzmi ilə Dofi tədricən həyata keçdi. Bu robot yalnız bizə aid deyil; o, yaradıcılığın, əməkdaşlığın və doğru insanlar bir araya gəldikdə baş verən sehrin mozaikasıdır."
        },
    },
    tr: {
        translation: {

            products: require('./locales/tr/products.json'),

            hero_page_title: "Hoş geldiniz!",
            hero_page_subtitle: "Akıllı, Güvenli ve Her Çocuk İçin Süper Eğlenceli!",
            hero_page_button: "Şimdi ön sipariş ver",
            home_screen_products_title: "Dofi İş Başında",
            add_to_cart_text: "Sepete ekle",
            about_title: "İçeride",
            about_description: "Robotumuz, çocukların gelişimini desteklemek için sesli komutla etkileşim, ebeveyn kontrolüyle görüntülü arama ve dinamik vücut ile yüz ifadeleri sunan akıllı ve eğlenceli bir yardımcıdır. Çocukların ana dillerini ve İngilizceyi öğrenmelerine, etkileşimli hikaye anlatımıyla eğlenmelerine ve güçlü matematik ve mantık becerileri geliştirmelerine yardımcı olur.",
            about_feature_part1: "Bilişsel Gelişim",
            about_feature_part2: "Gelişmiş Problem Çözme",
            about_feature_part3: "Uyarlanabilir Öğrenme",
            about_feature_part4: "Kişiselleştirilmiş Geri Bildirim",

            safety_page_title: "Yapay Zeka ve Güvenlik",
            safety_page_description: "Güvenliği ciddiye alıyoruz. Çocuğunuzun verilerinin her baytı kapalı sistemimizde korunur. Dofi, aile dostu yapay zeka konusunda yeni bir standart belirliyor.",
            safety_page_feature_title_part1: "Ebeveynler için faydalı",
            safety_page_feature_desciption_part1: "Güvenli aramalardan gerçek zamanlı gelişim raporlarına kadar",
            safety_page_feature_title_part2: "Daha iyi ebeveynlik araçları",
            safety_page_feature_description_part2: "Çocuğun eğitim planlarını açıkça sunan ve gelişimsel kilometre taşlarını belirleyen Ebeveyn Uygulaması",
            safety_page_feature_title_part3: "Güvenli, emniyetli ve özel",
            safety_page_feature_description_part3: "kidSAFE+ COPPA sertifikalı cihaz, özelleştirilebilir güvenlik ve gizlilik ayarları ile",

            faq_title: "Sıkça Sorulan Sorular",
            faq_question_part1: "Dofi nedir?",
            faq_answer_part1: "Dofi, çocuklar için tasarlanmış, kişiliği büyük ama boyutu küçük bir yapay zekâ destekli konuşan öğrenme robotudur.",
            faq_question_part2: "Dofi nasıl çalışır?",
            faq_answer_part2: "Dofi, gelişmiş yapay zekâ algoritmaları kullanarak çocuklarla etkileşime geçer, yeni beceriler öğretir ve eğlenceli bir öğrenme deneyimi sunar.",
            faq_question_part3: "Dofi çocuklar için güvenli mi?",
            faq_answer_part3: "Evet, Dofi güvenlik ön planda tutularak tasarlanmıştır. Gelişmiş şifreleme ve ebeveyn kontrolleri sayesinde çocuklar için güvenli ve emniyetli bir deneyim sağlar.",
            faq_question_part4: "Dofi hangi yaş grubu için uygundur?",
            faq_answer_part4: "Dofi, 3 ila 8 yaş arasındaki çocuklar için uygundur.",
            faq_question_part5: "Dofi'yi nasıl ön sipariş verebilirim?",
            faq_answer_part5: "Dofi'yi doğrudan web sitemizden ön sipariş verebilirsiniz. Ürünü sepete ekleyip ödeme adımlarını takip edin.",

            profile_page_title: "Kişisel bilgiler",
            profile_page_form_label1: "Ad Soyad",
            profile_page_form_label2: "E-posta",
            profile_page_form_label3: "İletişim numarası",
            profile_page_form_button: "Güncelle",
            profile_page_modal_desc: "Profiliniz başarıyla güncellendi",

            profile_orders_page_title: "Siparişleriniz",
            profile_order_card_part1: "Sipariş kodu",
            profile_order_card_part2: "Sipariş tarihi",
            profile_order_card_part3: "Detaylı bilgi",
            profile_order_card_part4: "Toplam fiyat",

            profile_orders_details_part1: "Teslimat",
            profile_orders_details_part2: "Ülke",
            profile_orders_details_part3: "Şehir",
            profile_orders_details_part4: "Adres",
            profile_orders_details_part5: "İletişim",
            profile_orders_details_part6: "Ad Soyad",
            profile_orders_details_part7: "E-posta",
            profile_orders_details_part8: "Telefon",
            profile_orders_details_part9: "Ödeme",
            profile_orders_details_part10: "Ödeme durumu",
            profile_orders_details_part11: "Ödeme tipi",
            profile_orders_details_part12: "Sipariş edilen ürünler",
            profile_orders_details_part13: "Fiyat",
            profile_orders_details_part14: "Teslimat",
            profile_orders_details_part15: "Toplam fiyat",
            profile_orders_details_part16: "İndirim",

            profile_security_page_title: "Güvenlik",
            profile_security_form_label1: "Mevcut şifre",
            profile_security_form_placeholder1: "Mevcut şifrenizi girin",
            profile_security_form_label2: "Yeni şifre",
            profile_security_form_placeholder2: "Yeni şifrenizi girin",
            profile_security_form_label3: "Şifreyi onayla",
            profile_security_form_placeholder3: "Şifrenizi onaylayın",
            profile_security_form_button: "Şifreyi değiştir",
            profile_security_modal_desc: "Şifreniz başarıyla güncellendi!",

            sidebar_title_profile: "Profil",
            sidebar_title_orders: "Siparişler",
            sidebar_title_security: "Güvenlik",
            sidebar_title_logout: "Çıkış yap",

            breadcrumb_home: "Ana sayfa",
            breadcrumb_profile: "Profil",
            breadcrumb_orders: "Siparişler",
            breadcrumb_order: "Sipariş",
            breadcrumb_security: "Güvenlik",

            footer_title1: "Ürünler",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Dofi çantası",
            footer_title2: "Kargo ve Politika",
            footer_part5: "Hakkında",
            footer_part6: "Kargo bilgileri",
            footer_part7: "İade Politikası",
            footer_part8: "Gizlilik Politikası",
            footer_part9: "Hizmet Şartları",
            footer_title3: "Bizi takip edin",
            footer_part10: "E-posta",
            footer_part11: "Telefon",
            footer_part12: "Tüm Hakları Saklıdır",

            product_details_part1: "Renk",
            product_details_part2: "Adet",
            product_details_part3: "Sepete ekle",
            product_details_part4: "Şimdi ön sipariş ver",
            product_details_part5: "Detaylı bilgi",
            product_details_part6: "Kargo ödeme sırasında hesaplanır",

            order_checkout_parttitle: "Ön sipariş sayfası",
            order_checkout_part1: "İletişim",
            order_checkout_part2: "E-posta",
            order_checkout_part3: "E-postanızı girin",
            order_checkout_part4: "Ad Soyad",
            order_checkout_part5: "Ad soyad yazın",
            order_checkout_part6: "Ülkenizi seçin",
            order_checkout_part7: "Şehrinizi seçin",
            order_checkout_part8: "Şehir seçin",
            order_checkout_part9: "Adres",
            order_checkout_part10: "Adresinizi girin",
            order_checkout_part11: "Daire",
            order_checkout_part12: "Dairenizi girin",
            order_checkout_part13: "İletişim",
            order_checkout_part14: "7 haneli numara",
            order_checkout_part15: "Ön siparişi onayla",
            order_checkout_part16: "Teslimat",
            order_checkout_part17: "Ülkenizi seçin",
            order_checkout_part18: "Siparişiniz ön sipariş olarak oluşturuldu",

            order_summary_title: "Sipariş özeti",
            order_summary_part1: "Renk",
            order_summary_part2: "Fiyat",
            order_summary_part3: "Promosyon kodu girin",
            order_summary_part4: "Kontrol et",
            order_summary_part5: "Ürün fiyatı",
            order_summary_part6: "Teslimat",
            order_summary_part7: "İndirim",
            order_summary_part8: "Toplam fiyat",
            order_summary_part9: "Sepetiniz boş",

            card_modal_title: "Sepet",
            cart_modal_footer: "Ödemeye geç",
            cart_modal_message1: "Alışverişe devam et",
            cart_modal_message2: "Sepetiniz boş",

            register_page_title: "Hesabınızı sadece bir tıkla oluşturun",
            register_page_label1: "Ad Soyad",
            register_page_input1: "Adınızı ve soyadınızı girin",
            register_page_label2: "E-posta",
            register_page_input2: "E-postanızı girin",
            register_page_label3: "Şifre",
            register_page_input3: "Şifrenizi girin",
            register_page_button: "Kayıt ol",
            register_page_footer1: "Zaten bir hesabınız var mı?",
            register_page_footer2: "Giriş yap",

            login_page_title: "Sizi yeniden görmek ne güzel!",
            login_page_label1: "E-posta",
            login_page_input1: "E-postanızı girin",
            login_page_label2: "Şifre",
            login_page_input2: "Şifrenizi girin",
            login_page_button: "Giriş yap",
            login_page_footer1: "Hesabınız yok mu?",
            login_page_footer2: "Kayıt ol",
            login_page_footer3: "Şifrenizi mi unuttunuz?",

            forgot_page_title: "Şifrenizi sıfırlayın",
            forgot_page_label1: "E-posta",
            forgot_page_input1: "E-postanızı girin",
            forgot_page_button: "Şifreyi değiştir",
            forgot_page_footer1: "Bir hesabınız var mı?",
            forgot_page_footer2: "Giriş yap",

            cart_page_part1: "Sepetiniz",
            cart_page_part2: "Devam et",
            cart_page_part3: "Ürün",
            cart_page_part4: "Adet",
            cart_page_part5: "Toplam Fiyat",
            cart_page_part6: "Ödemeye geç",

            modal_success_message_title: "Başarılı",
            modal_success_message_description: "Ürün sepete eklendi",
            modal_success_button: "Kapat",
            modal_error_message_title: "Hata",
            modal_error_message_description: "Bir hata oluştu",
            modal_error_button: "Kapat",
            modal_login_message_title: "Başarılı",
            modal_login_message_description: "Başarıyla giriş yaptınız!",
            modal_register_message_description: "Başarıyla kayıt oldunuz",

            about_page_title: "Merhaba, Dünya",
            about_page_title2: "Biz Dofi'yiz",
            about_page_description: "Her harika robotun arkasında meraklı bir zihin ve hayalperest bir ekip vardır. Dofi'nin nasıl hayata geçtiğini ve ona kalp veren insanları öğrenin.",
            about_page_info: "Dofi, Vugar Hasanov ve Sanan Muzaffarov arasında bir merak kıvılcımıyla başladı — canlı gibi hissedilen bir robot yapma hayaliyle. Laman Hasanova onun eğlenceli kişiliğini UI/UX ile şekillendirdi, Hüseyin ve Valida Adilova ikonik 3D formunu oluşturdu, Anar Aghazada ise grafik tasarımıyla görsel uyum kattı. Bir mentor topluluğunun rehberliğinde ve gece geç saatlerdeki fikirler ile inatçı problem çözümünden güç alarak Dofi yavaş yavaş hayata göz kırptı. Bu robot sadece bizim değil; bu, yaratıcılığın, iş birliğinin ve doğru insanlar bir araya geldiğinde oluşan sihrin bir mozaiğidir."
        },
    },
    ar: {
        translation: {

            products: require('./locales/ar/products.json'),

            hero_page_title: "مرحباً بك!",
            hero_page_subtitle: "ذكي، آمن، وممتع للغاية لكل طفل!",
            hero_page_button: "الطلب المسبق الآن",
            home_screen_products_title: "دوفي في العمل",
            add_to_cart_text: "أضف إلى السلة",
            about_title: "دوفي في الداخل",
            about_description: "روبوتنا هو رفيق ذكي وممتع مصمم لدعم تطوير الأطفال من خلال التفاعل مع الأوامر الصوتية، ومكالمات الفيديو مع رقابة الوالدين، وتعبيرات ديناميكية للجسم والوجه. يساعد الأطفال على تعلم لغتهم الأم والإنجليزية، والاستمتاع بالقصص التفاعلية، وتطوير مهاراتهم الرياضية والمنطقية، كل ذلك أثناء الاستمتاع.",
            about_feature_part1: "النمو المعرفي",
            about_feature_part2: "تحسين حل المشكلات",
            about_feature_part3: "التعلم التكيفي",
            about_feature_part4: "التغذية الراجعة المخصصة",

            safety_page_title: "الذكاء الاصطناعي والأمان",
            safety_page_description: "نحن نأخذ الأمان على محمل الجد. كل بايت من بيانات طفلك محمي ضمن نظامنا المغلق. دوفي يحدد معيارًا جديدًا للذكاء الاصطناعي الصديق للعائلة.",
            safety_page_feature_title_part1: "مفيد للآباء",
            safety_page_feature_desciption_part1: "من المكالمات الآمنة إلى التقارير اللحظية حول تقدم الطفل",
            safety_page_feature_title_part2: "أفضل الأدوات للآباء",
            safety_page_feature_description_part2: "تطبيق للآباء يعرض خطط تعلم الأطفال بوضوح ويحدد الإنجازات في تطورهم",
            safety_page_feature_title_part3: "آمن، محمي، وخاص",
            safety_page_feature_description_part3: "جهاز معتمد kidSAFE+ COPPA مع إعدادات أمان وخصوصية قابلة للتخصيص",

            // FAQ
            faq_title: "الأسئلة المتكررة",
            faq_question_part1: "ما هو دوفي؟",
            faq_answer_part1: "دوفي هو روبوت تعلم ذكي، مدعوم بالذكاء الاصطناعي، مصمم للأطفال، صغير الحجم ولكنه كبير في الشخصية.",
            faq_question_part2: "كيف يعمل دوفي؟",
            faq_answer_part2: "يستخدم دوفي خوارزميات متقدمة للذكاء الاصطناعي للتفاعل مع الأطفال، وتعليمهم مهارات جديدة، وتقديم تجربة تعلم ممتعة وجذابة.",
            faq_question_part3: "هل دوفي آمن للأطفال؟",
            faq_answer_part3: "نعم، دوفي مصمم مع أخذ الأمان في الاعتبار. يحتوي على تشفير متقدم وأدوات تحكم أبوية لضمان تجربة آمنة للأطفال.",
            faq_question_part4: "ما هي الفئة العمرية المناسبة لدخول دوفي؟",
            faq_answer_part4: "دوفي مناسب للأطفال الذين تتراوح أعمارهم بين 3 و 8 سنوات.",
            faq_question_part5: "كيف يمكنني طلب دوفي مسبقًا؟",
            faq_answer_part5: "يمكنك طلب دوفي مسبقًا مباشرة من خلال موقعنا الإلكتروني. أضف المنتج إلى السلة واستكمل الدفع.",

            // Profile
            profile_page_title: "معلومات شخصية",
            profile_page_form_label1: "الاسم الكامل",
            profile_page_form_label2: "البريد الإلكتروني",
            profile_page_form_label3: "رقم الاتصال",
            profile_page_form_button: "تحديث",
            profile_page_modal_desc: "تم تحديث ملفك الشخصي بنجاح",

            // Profile Orders
            profile_orders_page_title: "طلباتك",
            profile_order_card_part1: "رمز الطلب",
            profile_order_card_part2: "تاريخ الطلب",
            profile_order_card_part3: "تفاصيل الطلب",
            profile_order_card_part4: "السعر الإجمالي",

            // Profile Order Details Card
            profile_orders_details_part1: "الشحن",
            profile_orders_details_part2: "الدولة",
            profile_orders_details_part3: "المدينة",
            profile_orders_details_part4: "العنوان",
            profile_orders_details_part5: "التواصل",
            profile_orders_details_part6: "الاسم الكامل",
            profile_orders_details_part7: "البريد الإلكتروني",
            profile_orders_details_part8: "رقم الهاتف",
            profile_orders_details_part9: "الدفع",
            profile_orders_details_part10: "حالة الدفع",
            profile_orders_details_part11: "طريقة الدفع",
            profile_orders_details_part12: "المنتجات المطلوبة",
            profile_orders_details_part13: "السعر",
            profile_orders_details_part14: "الشحن",
            profile_orders_details_part15: "السعر الإجمالي",
            profile_orders_details_part16: "الخصم",

            // Profile Security
            profile_security_page_title: "الأمان",
            profile_security_form_label1: "كلمة المرور الحالية",
            profile_security_form_placeholder1: "أدخل كلمة المرور الحالية",
            profile_security_form_label2: "كلمة المرور الجديدة",
            profile_security_form_placeholder2: "أدخل كلمة المرور الجديدة",
            profile_security_form_label3: "تأكيد كلمة المرور",
            profile_security_form_placeholder3: "تأكيد كلمة المرور",
            profile_security_form_button: "تغيير كلمة المرور",
            profile_security_modal_desc: "تم تحديث كلمة المرور بنجاح!",

            // Sidebar
            sidebar_title_profile: "الملف الشخصي",
            sidebar_title_orders: "الطلبات",
            sidebar_title_security: "الأمان",
            sidebar_title_logout: "تسجيل الخروج",

            // Breadcrumb
            breadcrumb_home: "الرئيسية",
            breadcrumb_profile: "الملف الشخصي",
            breadcrumb_orders: "الطلبات",
            breadcrumb_order: "الطلب",
            breadcrumb_security: "الأمان",

            // Footer
            footer_title1: "المنتجات",
            footer_part1: "دوفي برو",
            footer_part2: "دوفي برو ميني",
            footer_part3: "دوفي ميني",
            footer_part4: "حقيبة دوفي",
            footer_title2: "الشحن والسياسات",
            footer_part5: "معلومات",
            footer_part6: "معلومات الشحن",
            footer_part7: "سياسة الإرجاع",
            footer_part8: "سياسة الخصوصية",
            footer_part9: "شروط الخدمة",
            footer_title3: "تابعنا",
            footer_part10: "البريد الإلكتروني",
            footer_part11: "رقم الهاتف",
            footer_part12: "جميع الحقوق محفوظة",

            // Product details
            product_details_part1: "اللون",
            product_details_part2: "الكمية",
            product_details_part3: "أضف إلى السلة",
            product_details_part4: "الطلب المسبق الآن",
            product_details_part5: "تفاصيل المنتج",
            product_details_part6: "سيتم احتساب الشحن عند إتمام الطلب",

            // Order 
            order_checkout_parttitle: "صفحة الطلب المسبق",
            order_checkout_part1: "التواصل",
            order_checkout_part2: "البريد الإلكتروني",
            order_checkout_part3: "أدخل بريدك الإلكتروني",
            order_checkout_part4: "الاسم الكامل",
            order_checkout_part5: "أدخل اسمك الكامل",
            order_checkout_part6: "اختار دولتك",
            order_checkout_part7: "اختار مدينتك",
            order_checkout_part8: "اختار مدينتك",
            order_checkout_part9: "العنوان",
            order_checkout_part10: "أدخل عنوانك",
            order_checkout_part11: "الشقة",
            order_checkout_part12: "أدخل شقتك",
            order_checkout_part13: "التواصل",
            order_checkout_part14: "رقم مكون من 7 أرقام",
            order_checkout_part15: "تأكيد الطلب المسبق",
            order_checkout_part16: "الشحن",
            order_checkout_part17: "اختار دولتك",
            order_checkout_part18: "تم إنشاء طلبك كطلب مسبق",

            // Order Summary
            order_summary_title: "ملخص الطلب",
            order_summary_part1: "اللون",
            order_summary_part2: "السعر",
            order_summary_part3: "أدخل الرمز الترويجي",
            order_summary_part4: "التحقق",
            order_summary_part5: "سعر المنتج",
            order_summary_part6: "الشحن",
            order_summary_part7: "الخصم",
            order_summary_part8: "السعر الإجمالي",
            order_summary_part9: "سلتك فارغة",

            // Card modal
            card_modal_title: "السلة",
            cart_modal_footer: "تابع إلى الدفع",
            cart_modal_message1: "متابعة التسوق",
            cart_modal_message2: "سلتك فارغة",

            // Register
            register_page_title: "أنشئ حسابك الآن بنقرة واحدة",
            register_page_label1: "الاسم الكامل",
            register_page_input1: "أدخل اسمك الكامل",
            register_page_label2: "البريد الإلكتروني",
            register_page_input2: "أدخل بريدك الإلكتروني",
            register_page_label3: "كلمة المرور",
            register_page_input3: "أدخل كلمة المرور",
            register_page_button: "تسجيل",
            register_page_footer1: "هل لديك حساب بالفعل؟",
            register_page_footer2: "تسجيل الدخول",

            // Login
            login_page_title: "سعداء لرؤيتك مرة أخرى!",
            login_page_label1: "البريد الإلكتروني",
            login_page_input1: "أدخل بريدك الإلكتروني",
            login_page_label2: "كلمة المرور",
            login_page_input2: "أدخل كلمة المرور",
            login_page_button: "تسجيل الدخول",
            login_page_footer1: "ليس لديك حساب؟",
            login_page_footer2: "سجل الآن",
            login_page_footer3: "نسيت كلمة المرور؟",

            // Forgot
            forgot_page_title: "استرجاع كلمة المرور",
            forgot_page_label1: "البريد الإلكتروني",
            forgot_page_input1: "أدخل بريدك الإلكتروني",
            forgot_page_button: "تغيير كلمة المرور",
            forgot_page_footer1: "هل لديك حساب؟",
            forgot_page_footer2: "تسجيل الدخول",

            // Cart
            cart_page_part1: "سلتك",
            cart_page_part2: "تابع",
            cart_page_part3: "المنتج",
            cart_page_part4: "الكمية",
            cart_page_part5: "السعر الإجمالي",
            cart_page_part6: "تابع إلى الدفع",

            modal_success_message_title: "نجاح",
            modal_success_message_description: "تم إضافة المنتج إلى السلة",
            modal_success_button: "إغلاق",
            modal_error_message_title: "خطأ",
            modal_error_message_description: "حدث خطأ",
            modal_error_button: "إغلاق",
            modal_login_message_title: "نجاح",
            modal_login_message_description: "لقد قمت بتسجيل الدخول بنجاح!",
            modal_register_message_description: "تم تسجيلك بنجاح!",

            about_page_title: "مرحباً، أيها العالم",
            about_page_title2: "نحن دوفي",
            about_page_description: "وراء كل روبوت عظيم عقل فضولي وفريق من الحالمين. تعرف على كيف وُلد دوفي — وعلى الأشخاص الذين منحوه قلباً.",
            about_page_info: "بدأت دوفي كشرارة فضول بين ووقار حسنوف وسنان مظفرُف — حلم مشترك لبناء روبوت يبدو حيًا. قامت لامان حسنوفا بتشكيل شخصيته المرحة من خلال تصميم UI/UX، بينما صمم حسين وفاليدا أديلوفا شكله ثلاثي الأبعاد الأيقوني، وأضاف أنار أغازاده لمسة من الانسجام البصري من خلال تصميمه الجرافيكي. بدعم من مجتمع من الموجهين، وأفكار منتصف الليل، والإصرار على حل المشكلات، ظهرت دوفي إلى الوجود شيئًا فشيئًا. هذا الروبوت ليس ملكًا لنا فقط؛ إنه فسيفساء من الإبداع والتعاون والسحر الذي يحدث عندما يجتمع الأشخاص المناسبون."
        },
    },
    fr: {
        translation: {

            products: require('./locales/fr/products.json'),

            hero_page_title: "Bienvenue !",
            hero_page_subtitle: "Intelligent, sûr et super amusant pour chaque enfant !",
            hero_page_button: "Précommandez maintenant",
            home_screen_products_title: "Dofi en action",
            add_to_cart_text: "Ajouter au panier",
            about_title: "à l'intérieur",
            about_description: "Notre robot est un compagnon intelligent et engageant conçu pour accompagner le développement des enfants grâce à l'interaction par commande vocale, aux appels vidéo avec contrôle parental, et à des expressions corporelles et faciales dynamiques. Il aide les enfants à apprendre leur langue maternelle et l'anglais, à profiter de contes interactifs et à développer de solides compétences en mathématiques et en logique, tout en s'amusant.",
            about_feature_part1: "Croissance cognitive",
            about_feature_part2: "Résolution de problèmes améliorée",
            about_feature_part3: "Apprentissage adaptatif",
            about_feature_part4: "Retour personnalisé",

            safety_page_title: "Intelligence artificielle et sécurité",
            safety_page_description: "Nous prenons la sécurité très au sérieux. Chaque octet des données de votre enfant est protégé dans notre système fermé. Dofi établit une nouvelle norme pour l'intelligence artificielle adaptée aux familles.",
            safety_page_feature_title_part1: "Utile pour les parents",
            safety_page_feature_desciption_part1: "Des appels sécurisés aux rapports de progrès en temps réel",
            safety_page_feature_title_part2: "Meilleurs outils parentaux",
            safety_page_feature_description_part2: "Application parentale qui présente clairement les plans éducatifs de l'enfant et identifie les étapes du développement",
            safety_page_feature_title_part3: "Sûr, sécurisé et privé",
            safety_page_feature_description_part3: "Appareil certifié kidSAFE+ COPPA avec des paramètres de sécurité et de confidentialité personnalisables",

            faq_title: "Questions fréquemment posées",
            faq_question_part1: "Qu'est-ce que Dofi ?",
            faq_answer_part1: "Dofi est un robot d'apprentissage parlant alimenté par l'IA, conçu pour les enfants, petit par la taille mais grand par la personnalité.",
            faq_question_part2: "Comment fonctionne Dofi ?",
            faq_answer_part2: "Dofi utilise des algorithmes d'intelligence artificielle avancés pour interagir avec les enfants, leur enseigner de nouvelles compétences et offrir une expérience d'apprentissage amusante et engageante.",
            faq_question_part3: "Dofi est-il sûr pour les enfants ?",
            faq_answer_part3: "Oui, Dofi est conçu en pensant à la sécurité. Il dispose d'un cryptage renforcé et de contrôles parentaux pour garantir une expérience sûre et sécurisée pour les enfants.",
            faq_question_part4: "À quel groupe d'âge Dofi convient-il ?",
            faq_answer_part4: "Dofi convient aux enfants âgés de 3 à 8 ans.",
            faq_question_part5: "Comment précommander Dofi ?",
            faq_answer_part5: "Vous pouvez précommander Dofi directement depuis notre site web. Il suffit d'ajouter le produit à votre panier et de procéder au paiement.",

            profile_page_title: "Informations personnelles",
            profile_page_form_label1: "Nom et prénom",
            profile_page_form_label2: "Email",
            profile_page_form_label3: "Numéro de contact",
            profile_page_form_button: "Mettre à jour",
            profile_page_modal_desc: "Votre profil a été mis à jour avec succès",

            profile_orders_page_title: "Vos commandes",
            profile_order_card_part1: "Code de commande",
            profile_order_card_part2: "Date de commande",
            profile_order_card_part3: "Informations détaillées",
            profile_order_card_part4: "Prix total",

            profile_orders_details_part1: "Livraison",
            profile_orders_details_part2: "Pays",
            profile_orders_details_part3: "Ville",
            profile_orders_details_part4: "Adresse",
            profile_orders_details_part5: "Contact",
            profile_orders_details_part6: "Nom complet",
            profile_orders_details_part7: "Email",
            profile_orders_details_part8: "Téléphone",
            profile_orders_details_part9: "Paiement",
            profile_orders_details_part10: "Statut du paiement",
            profile_orders_details_part11: "Type de paiement",
            profile_orders_details_part12: "Produits commandés",
            profile_orders_details_part13: "Prix",
            profile_orders_details_part14: "Livraison",
            profile_orders_details_part15: "Prix total",
            profile_orders_details_part16: "Réduction",

            profile_security_page_title: "Sécurité",
            profile_security_form_label1: "Mot de passe actuel",
            profile_security_form_placeholder1: "Entrez votre mot de passe actuel",
            profile_security_form_label2: "Nouveau mot de passe",
            profile_security_form_placeholder2: "Entrez votre nouveau mot de passe",
            profile_security_form_label3: "Confirmer le mot de passe",
            profile_security_form_placeholder3: "Confirmez votre mot de passe",
            profile_security_form_button: "Changer le mot de passe",
            profile_security_modal_desc: "Votre mot de passe a été mis à jour avec succès !",

            sidebar_title_profile: "Profil",
            sidebar_title_orders: "Commandes",
            sidebar_title_security: "Sécurité",
            sidebar_title_logout: "Se déconnecter",

            breadcrumb_home: "Accueil",
            breadcrumb_profile: "Profil",
            breadcrumb_orders: "Commandes",
            breadcrumb_order: "Commande",
            breadcrumb_security: "Sécurité",

            footer_title1: "Produits",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Sac pour Dofi",
            footer_title2: "Livraison & Politique",
            footer_part5: "À propos",
            footer_part6: "Informations sur la livraison",
            footer_part7: "Politique de retour",
            footer_part8: "Politique de confidentialité",
            footer_part9: "Conditions d'utilisation",
            footer_title3: "Suivez-nous",
            footer_part10: "Email",
            footer_part11: "Téléphone",
            footer_part12: "Tous droits réservés",

            product_details_part1: "Couleur",
            product_details_part2: "Quantité",
            product_details_part3: "Ajouter au panier",
            product_details_part4: "Précommandez maintenant",
            product_details_part5: "Informations détaillées",
            product_details_part6: "Livraison calculée à la caisse",

            order_checkout_parttitle: "Page de précommande",
            order_checkout_part1: "Contact",
            order_checkout_part2: "Email",
            order_checkout_part3: "Entrez votre email",
            order_checkout_part4: "Nom complet",
            order_checkout_part5: "Entrez le nom complet",
            order_checkout_part6: "Choisissez votre pays",
            order_checkout_part7: "Choisissez votre ville",
            order_checkout_part8: "Sélectionnez votre ville",
            order_checkout_part9: "Adresse",
            order_checkout_part10: "Entrez votre adresse",
            order_checkout_part11: "Appartement",
            order_checkout_part12: "Entrez votre appartement",
            order_checkout_part13: "Contact",
            order_checkout_part14: "Numéro à 7 chiffres",
            order_checkout_part15: "Confirmer la précommande",
            order_checkout_part16: "Livraison",
            order_checkout_part17: "Sélectionnez votre pays",
            order_checkout_part18: "Votre commande a été créée comme précommande",

            order_summary_title: "Résumé de la commande",
            order_summary_part1: "Couleur",
            order_summary_part2: "Prix",
            order_summary_part3: "Entrez le code promo",
            order_summary_part4: "Vérifier",
            order_summary_part5: "Prix du produit",
            order_summary_part6: "Livraison",
            order_summary_part7: "Réduction",
            order_summary_part8: "Prix total",
            order_summary_part9: "Votre panier est vide",

            card_modal_title: "Panier",
            cart_modal_footer: "Passer à la caisse",
            cart_modal_message1: "Continuer vos achats",
            cart_modal_message2: "Votre panier est vide",

            register_page_title: "Créez votre compte en un clic",
            register_page_label1: "Nom et prénom",
            register_page_input1: "Entrez votre nom et prénom",
            register_page_label2: "Email",
            register_page_input2: "Entrez votre email",
            register_page_label3: "Mot de passe",
            register_page_input3: "Entrez votre mot de passe",
            register_page_button: "S'inscrire",
            register_page_footer1: "Vous avez déjà un compte",
            register_page_footer2: "Se connecter",

            login_page_title: "Nous sommes heureux de vous revoir !",
            login_page_label1: "Email",
            login_page_input1: "Entrez votre email",
            login_page_label2: "Mot de passe",
            login_page_input2: "Entrez votre mot de passe",
            login_page_button: "Connexion",
            login_page_footer1: "Vous n'avez pas de compte ?",
            login_page_footer2: "S'inscrire",
            login_page_footer3: "Mot de passe oublié",

            forgot_page_title: "Réinitialisez votre mot de passe",
            forgot_page_label1: "Email",
            forgot_page_input1: "Entrez votre email",
            forgot_page_button: "Changer le mot de passe",
            forgot_page_footer1: "Vous avez un compte ?",
            forgot_page_footer2: "Connexion",

            cart_page_part1: "Votre panier",
            cart_page_part2: "Continuer",
            cart_page_part3: "Produit",
            cart_page_part4: "Quantité",
            cart_page_part5: "Prix total",
            cart_page_part6: "Procéder au paiement",

            modal_success_message_title: "Succès",
            modal_success_message_description: "Produit ajouté au panier",
            modal_success_button: "Fermer",
            modal_error_message_title: "Erreur",
            modal_error_message_description: "Une erreur est survenue",
            modal_error_button: "Fermer",
            modal_login_message_title: "Succès",
            modal_login_message_description: "Connexion réussie !",
            modal_register_message_description: "Inscription réussie",

            about_page_title: "Bonjour, le monde",
            about_page_title2: "Nous sommes Dofi",
            about_page_description: "Derrière chaque grand robot se cache un esprit curieux et une équipe de rêveurs. Découvrez comment Dofi a vu le jour — et les humains qui lui ont donné un cœur.",
            about_page_info: "Dofi est née d’une étincelle de curiosité entre Vugar Hasanov et Sanan Muzaffarov — un rêve partagé de construire un robot qui semble vivant. Laman Hasanova a donné forme à sa personnalité ludique via l’UI/UX, Huseyn et Valida Adilova ont façonné sa forme 3D emblématique, et Anar Aghazada a apporté l’harmonie visuelle grâce à sa touche de design graphique. Guidée par une communauté de mentors et nourrie par des idées nocturnes et une résolution de problèmes obstinée, Dofi a lentement vu le jour. Ce robot n’est pas seulement le nôtre ; c’est une mosaïque de créativité, de collaboration, et de cette magie qui naît lorsque les bonnes personnes se réunissent."
        },
    },
    cn: {
        translation: {

            products: require('./locales/cn/products.json'),

            hero_page_title: "欢迎！",
            hero_page_subtitle: "每个孩子的智能、安全又超级有趣的伙伴！",
            hero_page_button: "立即预订",
            home_screen_products_title: "Dofi实景展示",
            add_to_cart_text: "加入购物车",
            about_title: "多菲内部",
            about_description: "我们的机器人是一个智能、有趣的伙伴，通过语音指令交互、家长控制的视频通话以及生动的表情和肢体动作，支持儿童发展。它帮助孩子学习母语和英语，享受互动故事，培养数学和逻辑能力，同时获得乐趣。",
            about_feature_part1: "认知发展",
            about_feature_part2: "增强解决问题能力",
            about_feature_part3: "自适应学习",
            about_feature_part4: "个性化反馈",

            safety_page_title: "人工智能与安全",
            safety_page_description: "我们高度重视安全性。您孩子的所有数据都在封闭系统中受到保护。Dofi为家庭友好型人工智能设立了新标准。",
            safety_page_feature_title_part1: "家长实用功能",
            safety_page_feature_desciption_part1: "从安全通话到实时进度报告",
            safety_page_feature_title_part2: "更优育儿工具",
            safety_page_feature_description_part2: "家长应用清晰展示孩子的教育计划和发展里程碑",
            safety_page_feature_title_part3: "安全可靠私密",
            safety_page_feature_description_part3: "通过kidSAFE+ COPPA认证，提供可定制的安全和隐私设置",

            // 常见问题
            faq_title: "常见问题",
            faq_question_part1: "什么是Dofi？",
            faq_answer_part1: "Dofi是一款专为儿童设计的AI驱动会说话的学习机器人，小巧体型却拥有丰富个性。",
            faq_question_part2: "Dofi如何工作？",
            faq_answer_part2: "Dofi通过先进的人工智能算法与儿童互动，教授新技能，提供有趣且引人入胜的学习体验。",
            faq_question_part3: "Dofi对孩子安全吗？",
            faq_answer_part3: "是的，Dofi以安全为核心设计，采用增强加密和家长控制功能，确保儿童使用安全。",
            faq_question_part4: "Dofi适合哪个年龄段？",
            faq_answer_part4: "Dofi适合3至8岁的儿童。",
            faq_question_part5: "如何预订Dofi？",
            faq_answer_part5: "您可以直接在我们的官网预订Dofi，只需将商品加入购物车并结算即可。",

            // 个人资料
            profile_page_title: "个人信息",
            profile_page_form_label1: "姓名",
            profile_page_form_label2: "电子邮箱",
            profile_page_form_label3: "联系电话",
            profile_page_form_button: "更新",
            profile_page_modal_desc: "您的资料已成功更新",

            // 订单相关
            profile_orders_page_title: "您的订单",
            profile_order_card_part1: "订单编号",
            profile_order_card_part2: "下单日期",
            profile_order_card_part3: "详细信息",
            profile_order_card_part4: "总金额",

            // 订单详情
            profile_orders_details_part1: "配送信息",
            profile_orders_details_part2: "国家",
            profile_orders_details_part3: "城市",
            profile_orders_details_part4: "地址",
            profile_orders_details_part5: "联系方式",
            profile_orders_details_part6: "收件人姓名",
            profile_orders_details_part7: "电子邮箱",
            profile_orders_details_part8: "电话",
            profile_orders_details_part9: "支付信息",
            profile_orders_details_part10: "支付状态",
            profile_orders_details_part11: "支付方式",
            profile_orders_details_part12: "订购商品",
            profile_orders_details_part13: "单价",
            profile_orders_details_part14: "运费",
            profile_orders_details_part15: "总计",
            profile_orders_details_part16: "折扣",

            // 账户安全
            profile_security_page_title: "账户安全",
            profile_security_form_label1: "当前密码",
            profile_security_form_placeholder1: "输入当前密码",
            profile_security_form_label2: "新密码",
            profile_security_form_placeholder2: "输入新密码",
            profile_security_form_label3: "确认密码",
            profile_security_form_placeholder3: "再次输入密码",
            profile_security_form_button: "修改密码",
            profile_security_modal_desc: "密码修改成功！",

            // 侧边栏
            sidebar_title_profile: "个人资料",
            sidebar_title_orders: "我的订单",
            sidebar_title_security: "账户安全",
            sidebar_title_logout: "退出登录",

            // 面包屑导航
            breadcrumb_home: "首页",
            breadcrumb_profile: "个人资料",
            breadcrumb_orders: "我的订单",
            breadcrumb_order: "订单详情",
            breadcrumb_security: "账户安全",

            // 页脚
            footer_title1: "产品系列",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Dofi专用背包",
            footer_title2: "配送与政策",
            footer_part5: "关于我们",
            footer_part6: "配送信息",
            footer_part7: "退换政策",
            footer_part8: "隐私政策",
            footer_part9: "服务条款",
            footer_title3: "关注我们",
            footer_part10: "电子邮箱",
            footer_part11: "联系电话",
            footer_part12: "版权所有",

            // 商品详情
            product_details_part1: "颜色",
            product_details_part2: "数量",
            product_details_part3: "加入购物车",
            product_details_part4: "立即预订",
            product_details_part5: "商品详情",
            product_details_part6: "运费结算时计算",

            // 订单结算
            order_checkout_parttitle: "预购页面",
            order_checkout_part1: "联系方式",
            order_checkout_part2: "电子邮箱",
            order_checkout_part3: "输入您的邮箱",
            order_checkout_part4: "收件人姓名",
            order_checkout_part5: "请输入全名",
            order_checkout_part6: "选择国家",
            order_checkout_part7: "选择城市",
            order_checkout_part8: "请选择城市",
            order_checkout_part9: "详细地址",
            order_checkout_part10: "输入街道地址",
            order_checkout_part11: "门牌号",
            order_checkout_part12: "输入门牌信息",
            order_checkout_part13: "联系电话",
            order_checkout_part14: "7位电话号码",
            order_checkout_part15: "确认预订",
            order_checkout_part16: "配送方式",
            order_checkout_part17: "选择国家",
            order_checkout_part18: "您的订单已创建为预售订单",

            // 订单摘要
            order_summary_title: "订单汇总",
            order_summary_part1: "颜色",
            order_summary_part2: "价格",
            order_summary_part3: "输入优惠码",
            order_summary_part4: "验证",
            order_summary_part5: "商品金额",
            order_summary_part6: "运费",
            order_summary_part7: "优惠折扣",
            order_summary_part8: "应付总额",
            order_summary_part9: "您的购物车是空的",

            // 购物车弹窗
            card_modal_title: "购物车",
            cart_modal_footer: "去结算",
            cart_modal_message1: "继续购物",
            cart_modal_message2: "购物车为空",

            // 注册
            register_page_title: "一键创建您的账户",
            register_page_label1: "姓名",
            register_page_input1: "输入您的姓名",
            register_page_label2: "电子邮箱",
            register_page_input2: "输入您的邮箱",
            register_page_label3: "密码",
            register_page_input3: "设置密码",
            register_page_button: "注册",
            register_page_footer1: "已有账户？",
            register_page_footer2: "立即登录",

            // 登录
            login_page_title: "欢迎回来！",
            login_page_label1: "电子邮箱",
            login_page_input1: "输入您的邮箱",
            login_page_label2: "密码",
            login_page_input2: "输入您的密码",
            login_page_button: "登录",
            login_page_footer1: "没有账户？",
            login_page_footer2: "立即注册",
            login_page_footer3: "忘记密码",

            // 密码找回
            forgot_page_title: "重置密码",
            forgot_page_label1: "电子邮箱",
            forgot_page_input1: "输入注册邮箱",
            forgot_page_button: "重置密码",
            forgot_page_footer1: "已有账户？",
            forgot_page_footer2: "立即登录",

            // 购物车页面
            cart_page_part1: "您的购物车",
            cart_page_part2: "继续购物",
            cart_page_part3: "商品",
            cart_page_part4: "数量",
            cart_page_part5: "总价",
            cart_page_part6: "去支付",

            // 提示弹窗
            modal_success_message_title: "操作成功",
            modal_success_message_description: "商品已加入购物车",
            modal_success_button: "关闭",
            modal_error_message_title: "发生错误",
            modal_error_message_description: "出现异常错误",
            modal_error_button: "关闭",
            modal_login_message_title: "登录成功",
            modal_login_message_description: "您已成功登录！",
            modal_register_message_description: "您已成功注册",

            // About 
            about_page_title: "你好，世界",
            about_page_title2: "我们是 Dofi",
            about_page_description: "每一个伟大的机器人背后，都有一颗好奇的心和一群梦想家。了解 Dofi 是如何诞生的——以及那些赋予它心灵的人。",
            about_page_info: "Dofi 起初是一束由 Vugar Hasanov 和 Sanan Muzaffarov 激发的好奇心火花 —— 一个共同的梦想，希望创造出一个充满生命感的机器人。Laman Hasanova 通过 UI/UX 设计赋予了它活泼的个性，Huseyn 和 Valida Adilova 塑造了它标志性的 3D 形态，而 Anar Aghazada 则用他的平面设计为其带来了视觉上的和谐。在一群导师的引导下，借助深夜的灵感和顽强的问题解决精神，Dofi 慢慢诞生了。这个机器人不仅仅属于我们；它是一幅由创造力、协作精神以及当合适的人聚在一起时所产生的魔力拼接而成的马赛克。"
        },
    },
    de: {
        translation: {

            products: require('./locales/de/products.json'),

            hero_page_title: "Willkommen!",
            hero_page_subtitle: "Intelligent, sicher & super spaßig für jedes Kind!",
            hero_page_button: "Jetzt vorbestellen",
            home_screen_products_title: "Dofi in Aktion",
            add_to_cart_text: "In den Warenkorb",
            about_title: "Drinnen",
            about_description: "Unser Roboter ist ein intelligenter, ansprechender Begleiter, der die Entwicklung von Kindern durch Sprachbefehle, Videoanrufe mit Elternkontrollen und dynamische Körper- und Gesichtsausdrücke unterstützt. Er hilft Kindern, ihre Muttersprache und Englisch zu lernen, interaktive Geschichten zu genießen und starke Mathe- und Logikfähigkeiten aufzubauen – und das alles mit Spaß.",
            about_feature_part1: "Kognitive Entwicklung",
            about_feature_part2: "Verbesserte Problemlösung",
            about_feature_part3: "Adaptives Lernen",
            about_feature_part4: "Personalisiertes Feedback",

            safety_page_title: "Künstliche Intelligenz & Sicherheit",
            safety_page_description: "Sicherheit ist uns wichtig. Jedes Byte der Daten Ihres Kindes ist in unserem geschlossenen System geschützt. Dofi setzt neue Maßstäbe für familienfreundliche KI.",
            safety_page_feature_title_part1: "Nützlich für Eltern",
            safety_page_feature_desciption_part1: "Von sicheren Anrufen bis zu Echtzeit-Fortschrittsberichten",
            safety_page_feature_title_part2: "Bessere Eltern-Tools",
            safety_page_feature_description_part2: "Eltern-App mit klaren Bildungsplänen und Entwicklungsmeilensteinen",
            safety_page_feature_title_part3: "Sicher & privat",
            safety_page_feature_description_part3: "kidSAFE+ COPPA-zertifiziert mit anpassbaren Sicherheitseinstellungen",

            // FAQ
            faq_title: "Häufige Fragen",
            faq_question_part1: "Was ist Dofi?",
            faq_answer_part1: "Dofi ist ein KI-gesteuerter Lernroboter für Kinder – klein an Größe, aber mit großem Charakter.",
            faq_question_part2: "Wie funktioniert Dofi?",
            faq_answer_part2: "Dofi nutzt fortschrittliche KI-Algorithmen, um mit Kindern zu interagieren, ihnen Fähigkeiten beizubringen und ein unterhaltsames Lernerlebnis zu bieten.",
            faq_question_part3: "Ist Dofi sicher für Kinder?",
            faq_answer_part3: "Ja, Dofi wurde mit Sicherheit im Blick entwickelt. Er verfügt über erweiterte Verschlüsselung und Elternkontrollen.",
            faq_question_part4: "Für welches Alter ist Dofi geeignet?",
            faq_answer_part4: "Dofi ist für Kinder zwischen 3 und 8 Jahren geeignet.",
            faq_question_part5: "Wie kann ich Dofi vorbestellen?",
            faq_answer_part5: "Sie können Dofi direkt auf unserer Website vorbestellen – einfach Produkt in den Warenkorb legen und zur Kasse gehen.",

            // Profil
            profile_page_title: "Persönliche Informationen",
            profile_page_form_label1: "Vor- und Nachname",
            profile_page_form_label2: "E-Mail",
            profile_page_form_label3: "Telefonnummer",
            profile_page_form_button: "Aktualisieren",
            profile_page_modal_desc: "Ihr Profil wurde erfolgreich aktualisiert",

            // Bestellungen
            profile_orders_page_title: "Ihre Bestellungen",
            profile_order_card_part1: "Bestellnummer",
            profile_order_card_part2: "Bestelldatum",
            profile_order_card_part3: "Details",
            profile_order_card_part4: "Gesamtbetrag",

            // Bestelldetails
            profile_orders_details_part1: "Lieferung",
            profile_orders_details_part2: "Land",
            profile_orders_details_part3: "Stadt",
            profile_orders_details_part4: "Adresse",
            profile_orders_details_part5: "Kontakt",
            profile_orders_details_part6: "Vollständiger Name",
            profile_orders_details_part7: "E-Mail",
            profile_orders_details_part8: "Telefon",
            profile_orders_details_part9: "Zahlung",
            profile_orders_details_part10: "Zahlungsstatus",
            profile_orders_details_part11: "Zahlungsart",
            profile_orders_details_part12: "Bestellte Produkte",
            profile_orders_details_part13: "Preis",
            profile_orders_details_part14: "Versand",
            profile_orders_details_part15: "Gesamtbetrag",
            profile_orders_details_part16: "Rabatt",

            // Sicherheit
            profile_security_page_title: "Sicherheit",
            profile_security_form_label1: "Aktuelles Passwort",
            profile_security_form_placeholder1: "Aktuelles Passwort eingeben",
            profile_security_form_label2: "Neues Passwort",
            profile_security_form_placeholder2: "Neues Passwort eingeben",
            profile_security_form_label3: "Passwort bestätigen",
            profile_security_form_placeholder3: "Passwort wiederholen",
            profile_security_form_button: "Passwort ändern",
            profile_security_modal_desc: "Ihr Passwort wurde erfolgreich geändert!",

            // Sidebar
            sidebar_title_profile: "Profil",
            sidebar_title_orders: "Bestellungen",
            sidebar_title_security: "Sicherheit",
            sidebar_title_logout: "Abmelden",

            // Breadcrumb
            breadcrumb_home: "Startseite",
            breadcrumb_profile: "Profil",
            breadcrumb_orders: "Bestellungen",
            breadcrumb_order: "Bestellung",
            breadcrumb_security: "Sicherheit",

            // Footer
            footer_title1: "Produkte",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Tasche für Dofi",
            footer_title2: "Versand & Richtlinien",
            footer_part5: "Über uns",
            footer_part6: "Versandinformation",
            footer_part7: "Rückgaberecht",
            footer_part8: "Datenschutz",
            footer_part9: "Nutzungsbedingungen",
            footer_title3: "Folgen Sie uns",
            footer_part10: "E-Mail",
            footer_part11: "Telefon",
            footer_part12: "Alle Rechte vorbehalten",

            // Produktdetails
            product_details_part1: "Farbe",
            product_details_part2: "Menge",
            product_details_part3: "In den Warenkorb",
            product_details_part4: "Jetzt vorbestellen",
            product_details_part5: "Detaillierte Informationen",
            product_details_part6: "Versandkosten an der Kasse",

            // Bestellvorgang
            order_checkout_parttitle: "Vorbestellungsseite",
            order_checkout_part1: "Kontakt",
            order_checkout_part2: "E-Mail",
            order_checkout_part3: "Ihre E-Mail eingeben",
            order_checkout_part4: "Vollständiger Name",
            order_checkout_part5: "Vor- und Nachname eingeben",
            order_checkout_part6: "Land auswählen",
            order_checkout_part7: "Stadt auswählen",
            order_checkout_part8: "Ihre Stadt auswählen",
            order_checkout_part9: "Adresse",
            order_checkout_part10: "Straße und Hausnummer",
            order_checkout_part11: "Wohnung",
            order_checkout_part12: "Wohnungsnummer eingeben",
            order_checkout_part13: "Telefon",
            order_checkout_part14: "7-stellige Nummer",
            order_checkout_part15: "Vorbestellung bestätigen",
            order_checkout_part16: "Lieferung",
            order_checkout_part17: "Land auswählen",
            order_checkout_part18: "Ihre Vorbestellung wurde angelegt",

            // Bestellübersicht
            order_summary_title: "Bestellübersicht",
            order_summary_part1: "Farbe",
            order_summary_part2: "Preis",
            order_summary_part3: "Gutscheincode eingeben",
            order_summary_part4: "Prüfen",
            order_summary_part5: "Produktpreis",
            order_summary_part6: "Versand",
            order_summary_part7: "Rabatt",
            order_summary_part8: "Gesamtbetrag",
            order_summary_part9: "Ihr Warenkorb ist leer",

            // Warenkorb-Modal
            card_modal_title: "Warenkorb",
            cart_modal_footer: "Zur Kasse gehen",
            cart_modal_message1: "Einkauf fortsetzen",
            cart_modal_message2: "Ihr Warenkorb ist leer",

            // Registrierung
            register_page_title: "Erstellen Sie jetzt Ihr Konto",
            register_page_label1: "Vor- und Nachname",
            register_page_input1: "Ihren Namen eingeben",
            register_page_label2: "E-Mail",
            register_page_input2: "Ihre E-Mail eingeben",
            register_page_label3: "Passwort",
            register_page_input3: "Passwort erstellen",
            register_page_button: "Registrieren",
            register_page_footer1: "Sie haben bereits ein Konto?",
            register_page_footer2: "Anmelden",

            // Anmeldung
            login_page_title: "Willkommen zurück!",
            login_page_label1: "E-Mail",
            login_page_input1: "Ihre E-Mail eingeben",
            login_page_label2: "Passwort",
            login_page_input2: "Ihr Passwort eingeben",
            login_page_button: "Anmelden",
            login_page_footer1: "Sie haben kein Konto?",
            login_page_footer2: "Registrieren",
            login_page_footer3: "Passwort vergessen?",

            // Passwort vergessen
            forgot_page_title: "Passwort zurücksetzen",
            forgot_page_label1: "E-Mail",
            forgot_page_input1: "Ihre E-Mail eingeben",
            forgot_page_button: "Passwort zurücksetzen",
            forgot_page_footer1: "Sie haben ein Konto?",
            forgot_page_footer2: "Anmelden",

            // Warenkorb-Seite
            cart_page_part1: "Ihr Warenkorb",
            cart_page_part2: "Weiter einkaufen",
            cart_page_part3: "Produkt",
            cart_page_part4: "Menge",
            cart_page_part5: "Gesamtpreis",
            cart_page_part6: "Zur Zahlung",

            // Modale Nachrichten
            modal_success_message_title: "Erfolg",
            modal_success_message_description: "Produkt wurde hinzugefügt",
            modal_success_button: "Schließen",
            modal_error_message_title: "Fehler",
            modal_error_message_description: "Ein Fehler ist aufgetreten",
            modal_error_button: "Schließen",
            modal_login_message_title: "Anmeldung erfolgreich",
            modal_login_message_description: "Sie sind angemeldet!",
            modal_register_message_description: "Registrierung erfolgreich",

            // About
            about_page_title: "Hallo, Welt",
            about_page_title2: "Wir sind Dofi",
            about_page_description: "Hinter jedem großartigen Roboter steht ein neugieriger Geist und ein Team von Träumern. Erfahre, wie Dofi zum Leben erweckt wurde – und die Menschen, die ihm ein Herz gaben.",
            about_page_info: "Dofi begann als ein Funke der Neugier zwischen Vugar Hasanov und Sanan Muzaffarov — ein gemeinsamer Traum, einen Roboter zu bauen, der lebendig wirkt. Laman Hasanova formte seine verspielte Persönlichkeit durch UI/UX, Huseyn und Valida Adilova gestalteten seine ikonische 3D-Form, und Anar Aghazada brachte durch sein Grafikdesign visuelle Harmonie ein. Geleitet von einer Gemeinschaft von Mentoren und angetrieben durch nächtliche Ideen und hartnäckige Problemlösungen, erwachte Dofi langsam zum Leben. Dieser Roboter gehört nicht nur uns; er ist ein Mosaik aus Kreativität, Zusammenarbeit und jener Magie, die entsteht, wenn die richtigen Menschen zusammenkommen."
        },
    },
    es: {
        translation: {

            products: require('./locales/es/products.json'),

            hero_page_title: "¡Bienvenido!",
            hero_page_subtitle: "Inteligente, Seguro y Súper Divertido para Cada Niño!",
            hero_page_button: "Pre-pedido ahora",
            home_screen_products_title: "Dofi en Acción",
            add_to_cart_text: "Agregar al carrito",
            about_title: "en el interior",
            about_description: "Nuestro robot es un compañero inteligente y entretenido diseñado para apoyar el desarrollo de los niños a través de la interacción con comandos de voz, videollamadas con controles parentales y expresiones dinámicas del cuerpo y la cara. Ayuda a los niños a aprender tanto su lengua materna como el inglés, disfrutar de cuentos interactivos y desarrollar habilidades matemáticas y lógicas, todo mientras se divierten.",
            about_feature_part1: "Crecimiento Cognitivo",
            about_feature_part2: "Mejora de la Resolución de Problemas",
            about_feature_part3: "Aprendizaje Adaptativo",
            about_feature_part4: "Retroalimentación Personalizada",

            safety_page_title: "Inteligencia Artificial y Seguridad",
            safety_page_description: "Nos tomamos la seguridad en serio. Cada byte de datos de tu hijo está protegido dentro de nuestro sistema cerrado. Dofi establece un nuevo estándar para la inteligencia artificial amigable para la familia.",
            safety_page_feature_title_part1: "Útil para los padres",
            safety_page_feature_desciption_part1: "Desde llamadas seguras hasta informes en tiempo real sobre el progreso",
            safety_page_feature_title_part2: "Mejores herramientas para padres",
            safety_page_feature_description_part2: "Aplicación para padres que presenta claramente los planes educativos de los niños e identifica hitos en su desarrollo",
            safety_page_feature_title_part3: "Seguro, protegido y privado",
            safety_page_feature_description_part3: "Dispositivo certificado kidSAFE+ COPPA con configuraciones de seguridad y privacidad personalizables",

            // FAQ
            faq_title: "Preguntas Frecuentes",
            faq_question_part1: "¿Qué es Dofi?",
            faq_answer_part1: "Dofi es un robot de aprendizaje inteligente, impulsado por IA, diseñado para niños, pequeño en tamaño pero grande en personalidad.",
            faq_question_part2: "¿Cómo funciona Dofi?",
            faq_answer_part2: "Dofi utiliza algoritmos avanzados de inteligencia artificial para interactuar con los niños, enseñarles nuevas habilidades y proporcionarles una experiencia de aprendizaje divertida y atractiva.",
            faq_question_part3: "¿Es Dofi seguro para los niños?",
            faq_answer_part3: "Sí, Dofi está diseñado con la seguridad en mente. Cuenta con encriptación avanzada y controles parentales para garantizar una experiencia segura y protegida para los niños.",
            faq_question_part4: "¿Para qué rango de edad es adecuado Dofi?",
            faq_answer_part4: "Dofi es adecuado para niños entre 3 y 8 años.",
            faq_question_part5: "¿Cómo puedo hacer un pre-pedido de Dofi?",
            faq_answer_part5: "Puedes hacer un pre-pedido de Dofi directamente en nuestro sitio web. Agrega el producto al carrito y continúa con el pago.",

            // Profile
            profile_page_title: "Información Personal",
            profile_page_form_label1: "Nombre Completo",
            profile_page_form_label2: "Correo Electrónico",
            profile_page_form_label3: "Número de Contacto",
            profile_page_form_button: "Actualizar",
            profile_page_modal_desc: "Tu perfil ha sido actualizado con éxito",

            // Profile Orders
            profile_orders_page_title: "Tus Pedidos",
            profile_order_card_part1: "Código del pedido",
            profile_order_card_part2: "Fecha del pedido",
            profile_order_card_part3: "Detalles del pedido",
            profile_order_card_part4: "Precio total",

            // Profile Order Details Card
            profile_orders_details_part1: "Envío",
            profile_orders_details_part2: "País",
            profile_orders_details_part3: "Ciudad",
            profile_orders_details_part4: "Dirección",
            profile_orders_details_part5: "Contacto",
            profile_orders_details_part6: "Nombre Completo",
            profile_orders_details_part7: "Correo Electrónico",
            profile_orders_details_part8: "Teléfono",
            profile_orders_details_part9: "Pago",
            profile_orders_details_part10: "Estado del pago",
            profile_orders_details_part11: "Tipo de pago",
            profile_orders_details_part12: "Productos ordenados",
            profile_orders_details_part13: "Precio",
            profile_orders_details_part14: "Envío",
            profile_orders_details_part15: "Precio total",
            profile_orders_details_part16: "Descuento",

            // Profile Security
            profile_security_page_title: "Seguridad",
            profile_security_form_label1: "Contraseña actual",
            profile_security_form_placeholder1: "Introduce tu contraseña actual",
            profile_security_form_label2: "Nueva contraseña",
            profile_security_form_placeholder2: "Introduce tu nueva contraseña",
            profile_security_form_label3: "Confirmar contraseña",
            profile_security_form_placeholder3: "Confirma tu contraseña",
            profile_security_form_button: "Cambiar contraseña",
            profile_security_modal_desc: "¡Tu contraseña ha sido actualizada con éxito!",

            // Sidebar
            sidebar_title_profile: "Perfil",
            sidebar_title_orders: "Pedidos",
            sidebar_title_security: "Seguridad",
            sidebar_title_logout: "Cerrar sesión",

            // Breadcrumb
            breadcrumb_home: "Inicio",
            breadcrumb_profile: "Perfil",
            breadcrumb_orders: "Pedidos",
            breadcrumb_order: "Pedido",
            breadcrumb_security: "Seguridad",

            // Footer
            footer_title1: "Productos",
            footer_part1: "Dofi Pro",
            footer_part2: "Dofi Pro mini",
            footer_part3: "Dofi mini",
            footer_part4: "Bolsa para Dofi",
            footer_title2: "Envío y Políticas",
            footer_part5: "Información",
            footer_part6: "Información de envío",
            footer_part7: "Política de devoluciones",
            footer_part8: "Política de privacidad",
            footer_part9: "Términos de servicio",
            footer_title3: "Síguenos",
            footer_part10: "Correo Electrónico",
            footer_part11: "Teléfono",
            footer_part12: "Todos los derechos reservados",

            // Product details
            product_details_part1: "Color",
            product_details_part2: "Cantidad",
            product_details_part3: "Agregar al carrito",
            product_details_part4: "Pre-pedido ahora",
            product_details_part5: "Detalles del producto",
            product_details_part6: "Envío calculado al finalizar la compra",

            // Order checkout
            order_checkout_parttitle: "Página de pedido anticipado",
            order_checkout_part1: "Contacto",
            order_checkout_part2: "Correo electrónico",
            order_checkout_part3: "Introduce tu correo electrónico",
            order_checkout_part4: "Nombre completo",
            order_checkout_part5: "Introduce tu nombre completo",
            order_checkout_part6: "Selecciona tu país",
            order_checkout_part7: "Selecciona tu ciudad",
            order_checkout_part8: "Selecciona tu ciudad",
            order_checkout_part9: "Dirección",
            order_checkout_part10: "Introduce tu dirección",
            order_checkout_part11: "Apartamento",
            order_checkout_part12: "Introduce tu apartamento",
            order_checkout_part13: "Contacto",
            order_checkout_part14: "Número de 7 dígitos",
            order_checkout_part15: "Confirmar pre-pedido",
            order_checkout_part16: "Envío",
            order_checkout_part17: "Selecciona tu país",
            order_checkout_part18: "Tu pedido ha sido creado como pre-pedido",

            // Order Summary
            order_summary_title: "Resumen del Pedido",
            order_summary_part1: "Color",
            order_summary_part2: "Precio",
            order_summary_part3: "Introduce el código promocional",
            order_summary_part4: "Verificar",
            order_summary_part5: "Precio del producto",
            order_summary_part6: "Envío",
            order_summary_part7: "Descuento",
            order_summary_part8: "Precio total",
            order_summary_part9: "Tu carrito está vacío",

            // Card modal
            card_modal_title: "Carrito",
            cart_modal_footer: "Proceder al pago",
            cart_modal_message1: "Seguir comprando",
            cart_modal_message2: "Tu carrito está vacío",

            // Register
            register_page_title: "Crea tu cuenta ahora con un clic",
            register_page_label1: "Nombre completo",
            register_page_input1: "Introduce tu nombre completo",
            register_page_label2: "Correo electrónico",
            register_page_input2: "Introduce tu correo electrónico",
            register_page_label3: "Contraseña",
            register_page_input3: "Introduce tu contraseña",
            register_page_button: "Registrarse",
            register_page_footer1: "¿Ya tienes una cuenta?",
            register_page_footer2: "Iniciar sesión",

            // Login
            login_page_title: "¡Nos alegra verte de nuevo!",
            login_page_label1: "Correo electrónico",
            login_page_input1: "Introduce tu correo electrónico",
            login_page_label2: "Contraseña",
            login_page_input2: "Introduce tu contraseña",
            login_page_button: "Iniciar sesión",
            login_page_footer1: "¿No tienes cuenta?",
            login_page_footer2: "Regístrate",
            login_page_footer3: "¿Olvidaste tu contraseña?",

            // Forgot
            forgot_page_title: "Recupera tu contraseña",
            forgot_page_label1: "Correo electrónico",
            forgot_page_input1: "Introduce tu correo electrónico",
            forgot_page_button: "Cambiar contraseña",
            forgot_page_footer1: "¿Ya tienes cuenta?",
            forgot_page_footer2: "Iniciar sesión",

            // Cart
            cart_page_part1: "Tu carrito",
            cart_page_part2: "Seguir",
            cart_page_part3: "Producto",
            cart_page_part4: "Cantidad",
            cart_page_part5: "Precio total",
            cart_page_part6: "Proceder al pago",

            // Modal
            modal_success_message_title: "Éxito",
            modal_success_message_description: "Producto agregado al carrito",
            modal_success_button: "Cerrar",
            modal_error_message_title: "Error",
            modal_error_message_description: "Ocurrió un error",
            modal_error_button: "Cerrar",
            modal_login_message_title: "Éxito",
            modal_login_message_description: "¡Has iniciado sesión con éxito!",
            modal_register_message_description: "¡Te has registrado con éxito!",

            // About
            about_page_title: "Hola, Mundo",
            about_page_title2: "Somos Dofi",
            about_page_description: "Detrás de cada gran robot hay una mente curiosa y un equipo de soñadores. Descubre cómo nació Dofi—y las personas que le dieron un corazón.",
            about_page_info: "Dofi comenzó como una chispa de curiosidad entre Vugar Hasanov y Sanan Muzaffarov — un sueño compartido de construir un robot que pareciera estar vivo. Laman Hasanova dio forma a su personalidad juguetona a través del diseño UI/UX, Huseyn y Valida Adilova moldearon su icónica forma 3D, y Anar Aghazada aportó armonía visual con su toque de diseño gráfico. Guiado por una comunidad de mentores e impulsado por ideas nocturnas y una resolución de problemas persistente, Dofi fue cobrando vida poco a poco. Este robot no es solo nuestro; es un mosaico de creatividad, colaboración y la magia que ocurre cuando las personas adecuadas se unen."
        },
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
